var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFinetuneParametersStyle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m1.687 13.1.893.373v-6.02L.96 11.36c-.273.68.053 1.46.727 1.74m13-2.467-3.307-7.98a1.34 1.34 0 0 0-1.207-.82c-.173 0-.353.027-.526.1L4.733 3.967a1.333 1.333 0 0 0-.72 1.733l3.307 7.98a1.33 1.33 0 0 0 1.733.72l4.907-2.033a1.33 1.33 0 0 0 .727-1.734m-6.134 2.534L5.247 5.193l4.9-2.026h.006l3.3 7.966z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B7B7C2",
  d: "M7.333 6.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334M3.92 13.167c0 .733.6 1.333 1.333 1.333h.967l-2.3-5.56z"
})));
export default SvgFinetuneParametersStyle;